import { motion } from "framer-motion";

export default function AboutUs() {
  return (
    <section
      className="relative py-20 px-6 text-white"
      style={{
        backgroundImage: `linear-gradient(135deg, rgba(0,0,0,0.85), rgba(249,122,8,0.3)), url('/assets/s1.jpg')`,
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <div className="max-w-7xl mx-auto space-y-24">
        {/* 🔥 ABOUT */}
        <div className="text-center">
          <h1 className="text-5xl font-bold text-orange-400 mb-6">ABOUT US</h1>

          <div className="bg-black/40 backdrop-blur-xl p-6 rounded-xl border border-orange-500/20 max-w-3xl mx-auto">
            <p className="text-white/80 leading-relaxed">
              Solid-Era Energy delivers top-tier solar energy solutions for
              homes, businesses, and industries. We specialize in designing,
              installing, and maintaining efficient solar panel systems with
              24/7 support. Our mission is to reduce electricity costs and
              carbon emissions while building a greener and sustainable future.
            </p>
          </div>
        </div>

        {/* 🔥 BRANDS */}
        <div className="text-center">
          <h2 className="text-4xl text-orange-400 mb-10">Brands We Offer</h2>

          <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
            {[
              { file: "goodwe.png", name: "GoodWe" },
              { file: "Inverex-New-Logo.png", name: "Inverex" },
              { file: "JA.jpg", name: "JA Solar" },
              { file: "jinko.png", name: "Jinko Solar" },
              { file: "long.png", name: "Longi" },
              { file: "sol.png", name: "Sol" },
              { file: "trina.png", name: "Trina Solar" },
            ].map((brand, i) => (
              <motion.div
                key={i}
                whileHover={{ scale: 1.1 }}
                className="bg-black/40 p-4 rounded-xl border border-orange-500/20 flex items-center justify-center"
              >
                <img
                  src={`/assets/brands_logo/${brand.file}`}
                  alt={`${brand.name} solar energy brand`}
                  className="h-12 object-contain"
                />
              </motion.div>
            ))}
          </div>
        </div>

        {/* 🔥 WHY CHOOSE */}
        <div className="text-center">
          <h2 className="text-4xl text-orange-400 mb-6">Why Choose Us?</h2>

          <div className="bg-black/40 backdrop-blur-xl p-6 rounded-xl border border-orange-500/20 max-w-4xl mx-auto">
            <p className="text-white/80">
              We provide expert solar solutions tailored to your needs with a
              skilled team and years of experience. Our services include 24/7
              support, affordable pricing, and reliable maintenance ensuring
              long-term performance and customer satisfaction.
            </p>

            <div className="grid md:grid-cols-4 gap-6 mt-8">
              {["Expertise", "24/7 Support", "Affordable", "Reliable"].map(
                (item, i) => (
                  <div key={i} className="text-orange-400 font-semibold">
                    {item}
                  </div>
                ),
              )}
            </div>
          </div>
        </div>

        {/* 🔥 SERVICES */}
        <div className="text-center">
          <h2 className="text-4xl text-orange-400 mb-10">Our Services</h2>

          <div className="grid md:grid-cols-3 gap-6">
            {[
              {
                title: "Solar System Design",
                img: "/assets/portfolio/design.jpg",
              },
              {
                title: "Installation",
                img: "/assets/portfolio/industrial.jpg",
              },
              {
                title: "Maintenance",
                img: "/assets/portfolio/vendor.jpg",
              },
            ].map((s, i) => (
              <motion.div
                key={i}
                whileHover={{ scale: 1.05 }}
                className="bg-black/40 rounded-xl border border-orange-500/20 overflow-hidden"
              >
                <img
                  src={s.img}
                  alt={s.title}
                  className="h-48 w-full object-cover"
                />
                <p className="p-4">{s.title}</p>
              </motion.div>
            ))}
          </div>
        </div>

        {/* 🔥 VISION / MISSION */}
        <div className="grid md:grid-cols-2 gap-10">
          <div className="bg-black/40 p-6 rounded-xl border border-orange-500/20">
            <h2 className="text-orange-400 text-2xl mb-4">Our Vision</h2>
            <p>
              To be a leading provider of sustainable solar energy solutions,
              empowering communities to achieve energy independence.
            </p>
          </div>

          <div className="bg-black/40 p-6 rounded-xl border border-orange-500/20">
            <h2 className="text-orange-400 text-2xl mb-4">Our Mission</h2>
            <p>
              Deliver high-quality, cost-effective solar systems with excellent
              customer service and long-term reliability.
            </p>
          </div>
        </div>

        {/* 🔥 REGISTERED */}
        <div className="text-center">
          <h2 className="text-4xl text-orange-400 mb-10">Registered By</h2>

          <div className="flex justify-center gap-8 flex-wrap">
            {[
              {
                src: "secp.jpg",
                alt: "SECP - Securities and Exchange Commission of Pakistan",
              },
              { src: "pec.png", alt: "PEC - Pakistan Engineering Council" },
              { src: "fbr.jpg", alt: "FBR - Federal Board of Revenue" },
            ].map((logo, i) => (
              <div
                key={i}
                className="bg-black/40 p-4 rounded-xl border border-orange-500/20"
              >
                <img
                  src={`/assets/reg_logo/${logo.src}`}
                  alt={logo.alt}
                  className="h-16"
                />
              </div>
            ))}
          </div>
        </div>

        {/* 🔥 WHAT WE DO */}
        <div className="text-center">
          <h2 className="text-4xl text-orange-400 mb-6">What We Do</h2>

          <div className="bg-black/40 backdrop-blur-xl p-6 rounded-xl border border-orange-500/20 max-w-4xl mx-auto">
            <p className="text-white/80">
              We provide complete solar solutions including system design,
              installation, maintenance, and 24/7 support. Our goal is to help
              customers achieve energy efficiency and reduce electricity costs.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
